<template>
  <el-dialog title="派单记录" :visible.sync="dialogTableVisible" width="800px">
    <Table :data="list" :columns="columns" :loading="listLoading">
      <template v-slot:selection>
        <el-table-column width="50" align="center" type="selection" :selectable="checkSelectable">
        </el-table-column>
      </template>
      <template v-slot:interval_time>
        <el-table-column label="场次" width="100" align="center">
          <template slot-scope="scope"> {{ scope.row.interval_time }}场 </template>
        </el-table-column>
      </template>
      <template v-slot:contact>
        <el-table-column label="联系人" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.contact.name }}｜{{ scope.row.contact.mobile }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:trip_type>
        <el-table-column label="订单类型" width="100" align="center">
          <template slot-scope="scope"> {{ ['', '拼团', '包团'][scope.row.trip_type] }} </template>
        </el-table-column>
      </template>
      <template v-slot:guide>
        <el-table-column label="导游" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.guide.name }}｜{{ scope.row.guide.mobile }}
          </template>
        </el-table-column>
      </template>

      <template v-slot:add_time>
        <el-table-column label="派单时间" width="160" align="center">
          <template slot-scope="scope">
            <el-link type="info" :underline="false">{{ scope.row.add_time }}</el-link>
          </template>
        </el-table-column>
      </template>
      <template v-slot:is_arrived>
        <el-table-column label="客户状态" width="160" align="center">
          <template slot-scope="scope">
            <el-link type="info" :underline="false">{{
              scope.row.is_arrived ? '已到达' : '未到达'
            }}</el-link>
          </template>
        </el-table-column>
      </template>

      <template v-slot:send_status>
        <el-table-column label="短信状态" width="100" align="center">
          <template slot-scope="scope">
            {{ ['', '未发送', '已发送'][scope.row.send_status] }}
          </template>
        </el-table-column>
      </template>
    </Table>
  </el-dialog>
</template>

<script>
import { getList } from '@/api/assignRecord'

export default {
  name: 'AssignRecord',

  data() {
    return {
      dialogTableVisible: false,
      list: null,
      count: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 100,
        trip_service_id: ''
      },
      columns: [
        {
          type: 'index',
          align: 'center',
          label: '序号',
          width: '50'
        },
        {
          label: '订单编号',
          width: '150',
          prop: 'ota_sn'
        },
        {
          label: '数量',
          width: '80',
          prop: 'user_num',
          align: 'center'
        },
        {
          label: '出发日期',
          width: '120',
          prop: 'use_date',
          align: 'center'
        },
        {
          label: '场次',
          slot: 'interval_time'
        },
        {
          label: '项目',
          width: '120',
          prop: 'project_name',
          showOverflowTooltip: true
        },
        {
          label: '联系人',
          slot: 'contact'
        },
        {
          label: '订单类型',
          slot: 'trip_type'
        },
        {
          label: '导游信息',
          slot: 'guide'
        },

        {
          label: '派单时间',
          slot: 'add_time'
        },
        {
          label: '客户状态',
          slot: 'is_arrived'
        },
        {
          label: '短信状态',
          slot: 'send_status'
        }
      ]
    }
  },
  created() {},
  methods: {
    handleAssignRecord(trip_service_id) {
      this.listQuery.trip_service_id = trip_service_id
      this.fetchData()
      this.dialogTableVisible = true
    },
    // 获取数据
    fetchData() {
      this.listLoading = true
      const query = { ...this.listQuery }

      getList(query).then((res) => {
        this.list = res.data.results
        this.count = res.data.count
        this.listLoading = false
      })
    }
  }
}
</script>
